import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { Link } from "react-router-dom";
import {
  BioDevicelist,
  BioDevice,
  BioDeviceDelete,
  BioDeviceStatus,
} from "../../../api/StudentsAttendance";
import { formatDateTimeUtc, SweetAlertShow } from "../../master/Master";
import AttendanceHeader from "./AttendanceHeader";

const BioMetricDevice = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");

  const [deviceForm, setDeviceForm] = useState({
    device_Id: "",
    serial_number: "",
    device_location: "",
  });

  //   const [selectedDevice, setSelectedDevice] = useState(null);

  const fetchBio = async () => {
    setLoading(true);
    try {
      const res = await BioDevicelist();
      if (res?.data?.status) {
        setLogs(res.data.data);
      }
    } catch (err) {
      SweetAlertShow("error", "Error", err?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBio();
  }, []);

  const handleAddDevice = async () => {
    if (
      !deviceForm.device_Id ||
      !deviceForm.serial_number ||
      !deviceForm.device_location
    ) {
      SweetAlertShow("warning", "Required", "All fields are required");
      return;
    }

    try {
      setLoading(true);
      const res = await BioDevice(deviceForm);
      if (res?.data?.status) {
        SweetAlertShow("success", "Success", "Device added successfully");
        setDeviceForm({ device_Id: "", serial_number: "", device_location: "" });
        fetchBio();
        document.getElementById("closeAddDevice").click();
      }
    } catch (err) {
      SweetAlertShow("error", "Error", err?.message);
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = async () => {
    if (!selectedDevice) return;

    try {
      setLoading(true);
      console.log("dhfsfg", selectedDevice);
      const payload = {
        id: selectedDevice.id,
      };
      console.log("payload", payload);
      const res = await BioDeviceDelete(payload);
      console.log("res", res);

      if (res?.data?.status) {
        SweetAlertShow("success", "Deleted", res?.data?.message);

        setLogs((prev) =>
          prev.filter((dev) => dev.device_Id !== selectedDevice.device_Id)
        );

        document.getElementById("closeDeleteModal").click();
      } else {
        SweetAlertShow("error", "Error", res?.data?.message);
      }
    } catch (err) {
      SweetAlertShow("error", "Error", err?.message);
    } finally {
      setLoading(false);
    }
  };

  const confirmStatusChange = async () => {
    if (!selectedDevice) return;

    try {
      setLoading(true);

      const payload = {
        id: selectedDevice.id,
        status: selectedStatus,
      };

      const res = await BioDeviceStatus(payload);

      if (res?.data?.status) {
        SweetAlertShow("success", "Updated", res?.data?.message);

        setLogs((prev) =>
          prev.map((dev) =>
            dev.id === selectedDevice.id
              ? { ...dev, status: selectedStatus }
              : dev
          )
        );

        document.getElementById("closeStatusModal").click();
      } else {
        SweetAlertShow("error", "Error", res?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-primary" />
        </div>
      )}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />

            <div className="container-fluid mt-2">
              <div className="row custom-scroll-layout">
                <div className=" col-md-2 left-pane">
                  <AttendanceHeader data={"Attendance Portal "} />
                </div>
                <div className="col-12 col-md-10 right-pane">
                  <div className="card mb-2">
                    <div className="card-body d-flex justify-content-between">
                      <h3 className="text-primary">Biometric Device</h3>
                      <div>
                        <button
                          className="btn btn-primary me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#addDeviceModal"
                        >
                          + Add Device
                        </button>
                        {/* <Link to={-1} className="btn btn-outline-secondary">
                          ← Back
                        </Link> */}
                      </div>
                    </div>
                  </div>

                  <div className="card p-4">
                    <table className="table table-bordered text-center">
                      <thead className="table-primary">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Serial</th>
                          <th>Date</th>
                          <th>Status / Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {logs.length ? (
                          logs.map((d, i) => (
                            <tr key={d.id}>
                              <td>{i + 1}</td>
                              <td>{d.device_location}</td>
                              <td>{d.serial_number}</td>
                              <td>{formatDateTimeUtc(d.created_at)}</td>

                              <td>
                                <div className="d-flex gap-2 justify-content-center">
                                  <span
                                    role="button"
                                    className={`badge px-3 py-2 ${
                                      d.status === "1"
                                        ? "bg-success"
                                        : "bg-secondary"
                                    }`}
                                    data-bs-toggle="modal"
                                    data-bs-target="#statusModal"
                                    onClick={() => {
                                      setSelectedDevice(d);
                                      setSelectedStatus(d.status);
                                    }}
                                  >
                                    {d.status === "1" ? "Active" : "Inactive"}
                                  </span>

                                  <button
                                    className="btn btn-sm btn-danger"
                                    data-bs-toggle="modal"
                                    data-bs-target="#deleteModal"
                                    onClick={() => setSelectedDevice(d)}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5">No data found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="addDeviceModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5>Add Device</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeAddDevice"
              />
            </div>
            <div className="modal-body">
              {["device_Id", "serial_number", "device_location"].map((f) => (
                <input
                  key={f}
                  className="form-control mb-2"
                  placeholder={f.replace("_", " ").toUpperCase()}
                  value={deviceForm[f]}
                  onChange={(e) =>
                    setDeviceForm({ ...deviceForm, [f]: e.target.value })
                  }
                />
              ))}
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleAddDevice}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="statusModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Change Device Status</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeStatusModal"
              />
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Device Location</label>
                <input
                  className="form-control"
                  value={selectedDevice?.device_location || ""}
                  disabled
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Status</label>
                <select
                  className="form-select"
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>

              <button
                className="btn btn-primary"
                onClick={confirmStatusChange}
                disabled={loading}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="deleteModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5>Delete Device</h5>
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeDeleteModal"
              />
            </div>
            <div className="modal-body">
              Are you sure you want to delete{" "}
              <b>{selectedDevice?.device_location}</b>?
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>
              <button className="btn btn-danger" onClick={confirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BioMetricDevice;
